import { render, staticRenderFns } from "./ac5.vue?vue&type=template&id=644c662c&scoped=true&"
import script from "./ac5.vue?vue&type=script&lang=js&"
export * from "./ac5.vue?vue&type=script&lang=js&"
import style0 from "./ac5.vue?vue&type=style&index=0&id=644c662c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644c662c",
  null
  
)

export default component.exports